import { render, staticRenderFns } from "./PageFavorites.vue?vue&type=template&id=6ccbce74&scoped=true"
import script from "./PageFavorites.vue?vue&type=script&lang=js"
export * from "./PageFavorites.vue?vue&type=script&lang=js"
import style0 from "./PageFavorites.vue?vue&type=style&index=0&id=6ccbce74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbce74",
  null
  
)

export default component.exports